module.exports = __webpack_public_path__ + "static/media/favicon.0ce17ce5.svg";